









import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import DirectionSwitch from '@/layouts/back-office/misc/DirectionSwitch.vue';
import {SmartQuery} from 'vue-apollo/types/vue-apollo';
import VueSimpleContextMenu from 'vue-simple-context-menu';

@Component({
  components: {DirectionSwitch, VueSimpleContextMenu},
})
export default class MessageCategoryIsDone extends Vue {
  @Prop(Boolean) public show!: boolean;

}
